import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { buildAssetColumns } from './columns';
import { getAssetFields } from './fields';
import { getAssetSimpleFilters } from './simpleFilters';

/**
 * Generic QueryEntity - standalone entity reusing Asset columns and filters
 */
export const genericEntity: QueryEntity<unknown> = {
  primaryLabel: { actual: 'Generic', display: 'Generic' },
  buildColumns:
    buildAssetColumns as () => import('@/components/table/types').Columns<unknown>,
  getFields: getAssetFields,
  getSimpleFilters: getAssetSimpleFilters,
};
